import { render, staticRenderFns } from "./BundleLarge.vue?vue&type=template&id=2a59d260&"
import script from "./BundleLarge.vue?vue&type=script&lang=js&"
export * from "./BundleLarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports